import { CSSResult, css } from 'lit'

export const style: CSSResult = css`
  :host {
    align-items: var(--csc-carousel-item-align-items, center);
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    height: 100%;
    justify-content: center;
    width: 100%;
    scroll-snap-align: start;
    scroll-snap-stop: always;
  }
`
